import type { SelectedBundleOptionValue } from "@jti/magento";

export const getDiscountedPrice = (value: SelectedBundleOptionValue, currency: string) => {
  const { presentation_price, initial_price } = value.presentation_info;
  const hasDiscount = presentation_price && presentation_price !== initial_price;
  return hasDiscount ? { value: presentation_price, currency } : undefined;
};
